import {h, Fragment} from "preact"
export default function SubmitButton({ className, text }) {

    function handleSubmit(){
        if(window.outerWidth >= 990){
            document.querySelector('#desktop-search-Search-In-Template').form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
        } else {
            document.querySelector('#mobile-search-Search-In-Template').form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
        }
    }

    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-center ${className}`}>
            <button onClick={()=>{
                handleSubmit();
            }} type="submit" className="ns-act-btn ns-text-align-center ns-w-100">
                {text}
            </button>
        </div>
    )
}